"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FirstValue;
function FirstValue(value) {
    var Nothing = {
        bind: function bind(fn) {
            return FirstValue(fn.call(this));
        },
        val: function val() {
            return undefined;
        }
    };

    var Something = {
        bind: function bind(fn) {
            return this;
        },
        val: function val() {
            return value;
        }
    };

    if (value === undefined) return Nothing;else return Something;
}